/**
 * ZoomBridge — syncs the React Flow viewport zoom to a CSS custom property.
 *
 * Sets `--rf-zoom` on the DAG container so descendant nodes can use it in
 * pure-CSS `zoom` + counter-`scale()` rules without React re-renders.
 * Must be rendered as a child of `<ReactFlow>` (needs store access).
 */

import { useEffect } from "react";
import { useStore } from "@xyflow/react";

const zoomSelector = (s: { transform: [number, number, number] }) => s.transform[2];

export function ZoomBridge({ containerRef }: { containerRef: React.RefObject<HTMLDivElement | null> }) {
  const zoom = useStore(zoomSelector);

  useEffect(() => {
    containerRef.current?.style.setProperty("--rf-zoom", String(zoom));
  }, [zoom, containerRef]);

  return null;
}
